import { render, staticRenderFns } from "./AddAreas.vue?vue&type=template&id=2b87ed44&scoped=true"
import script from "./AddAreas.vue?vue&type=script&lang=js"
export * from "./AddAreas.vue?vue&type=script&lang=js"
import style0 from "./AddAreas.vue?vue&type=style&index=0&id=2b87ed44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87ed44",
  null
  
)

export default component.exports